import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'

axios.defaults.baseURL = 'https://xn--h1adlhdnlo2c.xn--p1ai/'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

